import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { EventTrackingService } from '@core/services/event-tracking.service';
import { EEventType } from '@enums/event-tracking.enum';
import { IAnalyticsNode, ICampaignAnalytics } from '@interfaces/campaign-analytics.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignExportDialogComponent } from '../campaign-export-dialog/campaign-export-dialog.component';
import { ICampaignExportDialogData } from '../campaign-export-dialog/campaign-export-dialog.interface';

@Component({
  imports: [MatButtonModule, MatMenuModule, TranslateModule, IconComponent],
  selector: 'app-campaign-export-button',
  templateUrl: './campaign-export-button.component.html',
})
export class CampaignExportButtonComponent {
  public readonly campaignAnalytics = input.required<ICampaignAnalytics | null>();
  public readonly analyticsNodes = input.required<IAnalyticsNode[] | null>();

  private readonly dialog = inject(MatDialog);
  private readonly eventTrackingService = inject(EventTrackingService);

  public onExportClick(): void {
    const data: ICampaignExportDialogData = {
      analyticsNodes: this.analyticsNodes(),
      campaignAnalytics: this.campaignAnalytics(),
    };

    this.dialog.open(CampaignExportDialogComponent, {
      data,
      disableClose: true,
      width: '880px',
    });

    this.eventTrackingService.track(EEventType.campaignReportingViewOpened, {
      campaignId: this.campaignAnalytics()?.id,
    });
  }
}
